import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/freebsd': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4 0.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1c-31.6 19.4-57.9 46.5-76.4 78.7-20.8-36.3-44.5-89.1-27.9-105.7 16.4-16.5 68 6.4 104.3 27zM406.7 174c3.3-5.5 7-11.8 10.9-18.8 17.6 31.3 27.7 67.4 27.7 105.8 0 119.1-96.5 215.6-215.6 215.6-119.1 0-215.6-96.6-215.6-215.6 0-119.1 96.5-215.6 215.6-215.6 35.9 0 69.7 8.8 99.5 24.3-7.3 4-13.9 8-19.6 11.6-26-4.7-32.9 16.4-14.9 48.7 21.8 43.1 89 90.4 109.3 70.1 5.4-5.4 6-14.8 2.7-26.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/freebsd.js
// module id = 841
// module chunks = 0